var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { SelectInput, TextInput, useRecordContext, SimpleForm, useGetOne, Toolbar, SaveButton, FormDataConsumer, useGetList, useUpdate, useNotify, useRefresh, required, RecordContext, BooleanInput, NumberInput, } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Tabs, Tab, Typography, Grid, Box, } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "@emotion/styled";
import { cloneDeep } from "lodash";
import { useTranslation } from "react-i18next";
import { CustomTabPanel } from "../../components/CustomTabPanel";
import { CandidatesOrder, EInvalidVotePolicy, EUnderVotePolicy, EEnableCheckableLists, isArray, EBlankVotePolicy, EOverVotePolicy, ECandidatesIconCheckboxPolicy, } from "@sequentech/ui-core";
import { DropFile } from "@sequentech/ui-essentials";
import { ICountingAlgorithm, IVotingType } from "./constants";
import { ContestStyles } from "../../components/styles/ContestStyles";
import FileJsonInput from "../../components/FileJsonInput";
import { useMutation } from "@apollo/client";
import { GET_UPLOAD_URL } from "@/queries/GetUploadUrl";
import { CandidateStyles } from "@/components/styles/CandidateStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { CircularProgress } from "@mui/material";
import CustomOrderInput from "@/components/custom-order/CustomOrderInput";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { useGetDocumentUrl } from "@/hooks/useGetDocumentUrl";
var CandidateRows = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 0.1rem;\n    padding: 1rem;\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 0.1rem;\n    padding: 1rem;\n"])));
var ListWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n    border: 1px solid #777;\n    padding: 8px;\n    margin-bottom: 4px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n    border: 1px solid #777;\n    padding: 8px;\n    margin-bottom: 4px;\n"])));
var uniqueArray = function (arr) {
    // Create a Set to store unique elements
    var uniqueSet = new Set();
    // Iterate through the array and add elements to the Set
    arr.forEach(function (item) {
        uniqueSet.add(item);
    });
    // Convert the Set back to an array and return it
    return Array.from(uniqueSet);
};
var ListsPresentationEditor = function (_a) {
    var _b, _c;
    var formData = _a.formData, candidates = _a.candidates, languageConf = _a.languageConf;
    var _d = useState(0), value = _d[0], setValue = _d[1];
    var t = useTranslation().t;
    var types = (_b = candidates === null || candidates === void 0 ? void 0 : candidates.map(function (candidate) { return candidate.type; }).filter(function (type) { return type; })) !== null && _b !== void 0 ? _b : [];
    types = uniqueArray(types);
    var typesMap = {};
    var _loop_1 = function (type) {
        var filteredCandidates = (_c = candidates === null || candidates === void 0 ? void 0 : candidates.filter(function (candidate) { return type === candidate.type; })) !== null && _c !== void 0 ? _c : [];
        var subtypes = filteredCandidates === null || filteredCandidates === void 0 ? void 0 : filteredCandidates.map(function (candidate) { var _a; return (_a = candidate.presentation) === null || _a === void 0 ? void 0 : _a.subtype; }).filter(function (subtype) { return subtype; });
        subtypes = uniqueArray(subtypes);
        var subtypesData = subtypes.map(function (subtype) { return ({
            name: subtype,
            candidates: filteredCandidates.filter(function (candidate) {
                var _a;
                return subtype ===
                    ((_a = candidate.presentation) === null || _a === void 0 ? void 0 : _a.subtype);
            }),
        }); });
        typesMap[type] = {
            name: type,
            candidates: filteredCandidates,
            subtypes: subtypesData,
        };
    };
    for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
        var type = types_1[_i];
        _loop_1(type);
    }
    var handleChange = function (_event, newValue) {
        setValue(newValue);
    };
    var renderTabs = function () {
        // reset actived tab to first tab if only one
        if (languageConf.length === 1 && value !== 0) {
            setValue(0);
        }
        return languageConf.map(function (lang) { return (_jsx(Tab, { label: t("common.language.".concat(lang)), id: lang }, lang)); });
    };
    var renderTabContent = function (type) {
        var tabNodes = [];
        var index = 0;
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(CustomTabPanel, __assign({ value: value, index: index }, { children: _jsx(Box, __assign({ style: { marginTop: "16px" } }, { children: _jsx(TextInput, { source: "presentation.types_presentation[".concat(type, "].name_i18n[").concat(lang, "]"), label: "List Name" }) })) }), lang));
            index++;
        });
        return tabNodes;
    };
    var renderSubtypeTabContent = function (type, subtype) {
        var tabNodes = [];
        var index = 0;
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(CustomTabPanel, __assign({ value: value, index: index }, { children: _jsx(Box, __assign({ style: { marginTop: "16px" } }, { children: _jsx(TextInput, { source: "presentation.types_presentation[".concat(type, "].subtypes_presentation[").concat(subtype, "].name_i18n[").concat(lang, "]"), label: "List Name" }) })) }), lang));
            index++;
        });
        return tabNodes;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", component: "span", sx: {
                    padding: "0.5rem 1rem",
                    fontWeight: "bold",
                    margin: 0,
                    display: { xs: "none", sm: "block" },
                } }, { children: "Edit Lists" })), types.map(function (type) {
                var _a;
                return (_jsxs(ListWrapper, { children: [_jsxs("i", { children: ["List: ", type] }), _jsx(NumberInput, { source: "presentation.types_presentation[".concat(type, "].sort_order"), min: 0, label: "Sort order" }), _jsx(Tabs, __assign({ value: value, onChange: handleChange }, { children: renderTabs() })), renderTabContent(type), _jsx(Typography, __assign({ variant: "body1", component: "span", sx: {
                                padding: "0.5rem 1rem",
                                fontWeight: "bold",
                                margin: 0,
                                display: { xs: "none", sm: "block" },
                            } }, { children: "Edit Subtypes" })), _jsx(Box, { children: (_a = typesMap[type]) === null || _a === void 0 ? void 0 : _a.subtypes.map(function (subtype) {
                                return (_jsxs(ListWrapper, { children: ["Subtype ", subtype.name, _jsx(NumberInput, { source: "presentation.types_presentation[".concat(type, "].subtypes_presentation[").concat(subtype.name, "].sort_order"), min: 0, label: "Sort order" }), _jsx(Tabs, __assign({ value: value, onChange: handleChange }, { children: renderTabs() })), renderSubtypeTabContent(type, subtype.name)] }, subtype.name));
                            }) })] }, type));
            })] }));
};
export var ContestDataForm = function () {
    var _a, _b;
    var record = useRecordContext();
    var t = useTranslation().t;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _c = useState(["en"]), languageConf = _c[0], setLanguageConf = _c[1];
    var getUploadUrl = useMutation(GET_UPLOAD_URL)[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var authContext = useContext(AuthContext);
    var getImageUrl = useGetDocumentUrl();
    var _d = useState(0), value = _d[0], setValue = _d[1];
    var _e = useState("contest-data-general"), expanded = _e[0], setExpanded = _e[1];
    var canEdit = authContext.isAuthorized(true, authContext.tenantId, IPermissions.CONTEST_WRITE);
    var electionEvent = useGetOne("sequent_backend_election_event", {
        id: record.election_event_id,
        meta: { tenant_id: record.tenant_id },
    }).data;
    var election = useGetOne("sequent_backend_election", {
        id: record.election_id,
    }).data;
    var _f = useGetOne("sequent_backend_document", {
        id: record.image_document_id || record.tenant_id,
        meta: { tenant_id: record.tenant_id },
    }), imageData = _f.data, refetchImage = _f.refetch;
    var updateImage = useUpdate()[0];
    var candidates = useGetList("sequent_backend_candidate", {
        filter: {
            contest_id: record.id,
            tenant_id: record.tenant_id,
            election_event_id: record.election_event_id,
        },
        pagination: { page: 1, perPage: 500 },
    }).data;
    useEffect(function () {
        var _a, _b;
        if (election) {
            var langConf = (_a = election.presentation) === null || _a === void 0 ? void 0 : _a.language_conf;
            if (langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes) {
                setLanguageConf(langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes);
                return;
            }
        }
        if (electionEvent) {
            var langConf = (_b = electionEvent.presentation) === null || _b === void 0 ? void 0 : _b.language_conf;
            if (langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes) {
                setLanguageConf(langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes);
                return;
            }
        }
    }, [(_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.language_conf, (_b = election === null || election === void 0 ? void 0 : election.presentation) === null || _b === void 0 ? void 0 : _b.language_conf]);
    var votingTypesChoices = function () {
        return Object.values(IVotingType).map(function (value) { return ({
            id: value,
            name: t("contestScreen.options.".concat(value.toLowerCase())),
        }); });
    };
    var countingAlgorithmChoices = function () {
        return Object.values(ICountingAlgorithm).map(function (value) { return ({
            id: value,
            name: t("contestScreen.options.".concat(value.toLowerCase())),
        }); });
    };
    var orderAnswerChoices = function () {
        return Object.values(CandidatesOrder).map(function (value) { return ({
            id: value,
            name: t("contestScreen.options.".concat(value.toLowerCase())),
        }); });
    };
    var invalidVotePolicyChoices = function () {
        return Object.values(EInvalidVotePolicy).map(function (value) { return ({
            id: value,
            name: t("contestScreen.invalidVotePolicy.".concat(value.toLowerCase())),
        }); });
    };
    var candidatesIconCheckboxPolicy = function () {
        return Object.values(ECandidatesIconCheckboxPolicy).map(function (value) { return ({
            id: value,
            name: t("contestScreen.candidatesIconCheckboxPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var underVotePolicyChoices = function () {
        return Object.values(EUnderVotePolicy).map(function (value) { return ({
            id: value,
            name: t("contestScreen.underVotePolicy.".concat(value.toLowerCase())),
        }); });
    };
    var checkableListChoices = function () {
        return Object.values(EEnableCheckableLists).map(function (value) { return ({
            id: value,
            name: t("contestScreen.checkableListPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var blankVotePolicyChoices = function () {
        return Object.values(EBlankVotePolicy).map(function (value) { return ({
            id: value,
            name: t("contestScreen.blankVotePolicy.".concat(value)),
        }); });
    };
    var overVotePolicyChoices = function () {
        return Object.values(EOverVotePolicy).map(function (value) { return ({
            id: value,
            name: t("contestScreen.overVotePolicy.".concat(value)),
        }); });
    };
    var parseValues = useCallback(function (incoming) {
        var _a;
        if (!electionEvent) {
            return incoming;
        }
        var newContest = cloneDeep(incoming);
        var newPresentation = ((_a = newContest.presentation) !== null && _a !== void 0 ? _a : {});
        newContest.presentation = newPresentation;
        // name, alias and description fields
        if (!newContest.presentation) {
            newContest.presentation = {};
        }
        if (!newContest.presentation.i18n) {
            newContest.presentation.i18n = {};
        }
        if (!newContest.presentation.i18n.en) {
            newContest.presentation.i18n.en = {};
        }
        if (!newContest.presentation.i18n.en.name && newContest.name) {
            newContest.presentation.i18n.en.name = newContest.name;
        }
        if (!newContest.presentation.i18n.en.alias && newContest.alias) {
            newContest.presentation.i18n.en.alias = newContest.alias;
        }
        if (!newContest.presentation.i18n.en.description && newContest.description) {
            newContest.presentation.i18n.en.description = newContest.description;
        }
        newContest.name = newContest.presentation.i18n.en.name;
        newContest.alias = newContest.presentation.i18n.en.alias;
        newContest.description = newContest.presentation.i18n.en.description;
        // defaults
        newContest.voting_type = newContest.voting_type || IVotingType.NON_PREFERENTIAL;
        newContest.counting_algorithm =
            newContest.counting_algorithm || ICountingAlgorithm.PLURALITY_AT_LARGE;
        newContest.min_votes = newContest.min_votes || 0;
        newContest.presentation.candidates_order =
            newContest.presentation.candidates_order || CandidatesOrder.ALPHABETICAL;
        newContest.presentation.invalid_vote_policy =
            newContest.presentation.invalid_vote_policy || EInvalidVotePolicy.ALLOWED;
        newContest.presentation.enable_checkable_lists =
            newContest.presentation.enable_checkable_lists ||
                EEnableCheckableLists.CANDIDATES_AND_LISTS;
        newContest.presentation.candidates_icon_checkbox_policy =
            newContest.presentation.candidates_icon_checkbox_policy ||
                ECandidatesIconCheckboxPolicy.SQUARE_CHECKBOX;
        newContest.presentation.under_vote_policy =
            newContest.presentation.under_vote_policy || EUnderVotePolicy.ALLOWED;
        newContest.presentation.blank_vote_policy =
            newContest.presentation.blank_vote_policy || EBlankVotePolicy.ALLOWED;
        newContest.presentation.over_vote_policy =
            newContest.presentation.over_vote_policy || EOverVotePolicy.ALLOWED;
        newContest.presentation.pagination_policy =
            newContest.presentation.pagination_policy || "";
        // Default allow_writeins to true if not set
        if (newContest.presentation.allow_writeins === undefined) {
            newContest.presentation.allow_writeins = false;
        }
        return newContest;
    }, [languageConf, electionEvent, candidates]);
    var handleChange = function (_event, newValue) {
        setValue(newValue);
    };
    var formValidator = function (values) {
        var _a, _b;
        var errors = { dates: {} };
        if (((_a = values === null || values === void 0 ? void 0 : values.dates) === null || _a === void 0 ? void 0 : _a.end_date) <= ((_b = values === null || values === void 0 ? void 0 : values.dates) === null || _b === void 0 ? void 0 : _b.start_date)) {
            errors.dates.end_date = t("electionEventScreen.error.endDate");
        }
        return errors;
    };
    var renderTabs = function () {
        var tabNodes = [];
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(Tab, { label: t("common.language.".concat(lang)), id: lang }, lang));
        });
        // reset actived tab to first tab if only one
        if (tabNodes.length === 1 && value !== 0) {
            setValue(0);
        }
        return tabNodes;
    };
    var renderTabContent = function () {
        var tabNodes = [];
        var index = 0;
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(CustomTabPanel, __assign({ value: value, index: index }, { children: _jsxs("div", __assign({ style: { marginTop: "16px" } }, { children: [_jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].name"), label: t("electionEventScreen.field.name") }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].alias"), label: t("electionEventScreen.field.alias") }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].description"), label: t("electionEventScreen.field.description") })] })) }), lang));
            index++;
        });
        return tabNodes;
    };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var theFile, _a, data, errors, e_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    theFile = files === null || files === void 0 ? void 0 : files[0];
                    if (!theFile) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUploadUrl({
                            variables: {
                                name: theFile.name,
                                media_type: theFile.type,
                                size: theFile.size,
                            },
                        })];
                case 1:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    if (!((_b = data === null || data === void 0 ? void 0 : data.get_upload_url) === null || _b === void 0 ? void 0 : _b.document_id)) return [3 /*break*/, 6];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fetch(data.get_upload_url.url, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "image/*",
                            },
                            body: theFile,
                        })];
                case 3:
                    _c.sent();
                    notify(t("electionScreen.error.fileLoaded"), { type: "success" });
                    updateImage("sequent_backend_contest", {
                        id: record.id,
                        data: {
                            image_document_id: data.get_upload_url.document_id,
                        },
                    });
                    refetchImage();
                    refresh();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    _c.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var sortedCandidates = (candidates !== null && candidates !== void 0 ? candidates : []).sort(function (a, b) {
        var _a, _b;
        var presentationA = a.presentation;
        var presentationB = b.presentation;
        var sortOrderA = (_a = presentationA === null || presentationA === void 0 ? void 0 : presentationA.sort_order) !== null && _a !== void 0 ? _a : -1;
        var sortOrderB = (_b = presentationB === null || presentationB === void 0 ? void 0 : presentationB.sort_order) !== null && _b !== void 0 ? _b : -1;
        return sortOrderA - sortOrderB;
    });
    return electionEvent && isArray(candidates) ? (_jsx(RecordContext.Consumer, { children: function (incoming) {
            var parsedValue = parseValues(incoming);
            var imageUrl = getImageUrl(parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.tenant_id, parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id, imageData === null || imageData === void 0 ? void 0 : imageData.name);
            return (_jsxs(SimpleForm, __assign({ defaultValues: { candidatesOrder: sortedCandidates }, validate: formValidator, record: parsedValue, toolbar: _jsx(Toolbar, { children: canEdit && _jsx(SaveButton, {}) }) }, { children: [_jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "contest-data-general", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "contest-data-general" ? "" : "contest-data-general";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "contest-data-general" }) }, { children: _jsx(ContestStyles.Wrapper, { children: _jsx(ContestStyles.Title, { children: t("contestScreen.edit.general") }) }) })), _jsxs(AccordionDetails, { children: [_jsx(Tabs, __assign({ value: value, onChange: handleChange }, { children: renderTabs() })), renderTabContent()] })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "contest-data-system", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "contest-data-system" ? "" : "contest-data-system";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "contest-data-system" }) }, { children: _jsx(ContestStyles.Wrapper, { children: _jsx(ContestStyles.Title, { children: t("contestScreen.edit.system") }) }) })), _jsxs(AccordionDetails, { children: [_jsx(SelectInput, { source: "voting_type", choices: votingTypesChoices(), validate: required() }), _jsx(SelectInput, { source: "counting_algorithm", choices: countingAlgorithmChoices(), validate: required() })] })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "contest-data-design", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "contest-data-design" ? "" : "contest-data-design";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "contest-data-design" }) }, { children: _jsx(ContestStyles.Wrapper, { children: _jsx(ContestStyles.Title, { children: t("contestScreen.edit.design") }) }) })), _jsxs(AccordionDetails, { children: [_jsx(BooleanInput, { source: "is_acclaimed" }), _jsx(BooleanInput, { source: "presentation.allow_writeins", label: String(t("contestScreen.allowWriteins.label")) }), _jsx(NumberInput, { source: "min_votes", min: 0 }), _jsx(NumberInput, { source: "max_votes", min: 0 }), _jsx(NumberInput, { source: "presentation.columns", min: 1 }), _jsx(NumberInput, { source: "winning_candidates_num", min: 0 }), _jsx(SelectInput, { source: "presentation.candidates_order", choices: orderAnswerChoices(), validate: required() }), _jsx(FormDataConsumer, { children: function (_a) {
                                            var _b;
                                            var formData = _a.formData, rest = __rest(_a, ["formData"]);
                                            return ((_b = formData === null || formData === void 0 ? void 0 : formData.presentation) === null || _b === void 0 ? void 0 : _b.candidates_order) === CandidatesOrder.CUSTOM ? (_jsxs(CandidateRows, { children: [_jsx(Typography, __assign({ variant: "body1", component: "span", sx: {
                                                            padding: "0.5rem 1rem",
                                                            fontWeight: "bold",
                                                            margin: 0,
                                                            display: { xs: "none", sm: "block" },
                                                        } }, { children: t("contestScreen.edit.reorder") })), _jsx(CustomOrderInput, { source: "candidatesOrder" }), _jsx(Box, { sx: { width: "100%", height: "180px" } })] })) : null;
                                        } }), _jsx(FormDataConsumer, { children: function (_a) {
                                            var formData = _a.formData, rest = __rest(_a, ["formData"]);
                                            return (_jsx(ListsPresentationEditor, { formData: formData, candidates: candidates, languageConf: languageConf }));
                                        } }), _jsx(SelectInput, { source: "presentation.enable_checkable_lists", choices: checkableListChoices(), validate: required() }), _jsx(NumberInput, { source: "presentation.max_selections_per_type", min: 0, isRequired: false }), _jsx(Typography, __assign({ variant: "body1", component: "span", sx: {
                                            padding: "0.5rem 1rem",
                                            fontWeight: "bold",
                                            margin: 0,
                                            display: { xs: "none", sm: "block" },
                                        } }, { children: t("contestScreen.edit.policies") })), _jsx(SelectInput, { source: "presentation.under_vote_policy", choices: underVotePolicyChoices(), label: t("contestScreen.underVotePolicy.label"), validate: required() }), _jsx(SelectInput, { source: "presentation.invalid_vote_policy", choices: invalidVotePolicyChoices(), label: t("contestScreen.invalidVotePolicy.label"), validate: required() }), _jsx(SelectInput, { source: "presentation.blank_vote_policy", choices: blankVotePolicyChoices(), label: t("contestScreen.blankVotePolicy.label"), defaultValue: EBlankVotePolicy.ALLOWED, validate: required() }), _jsx(SelectInput, { source: "presentation.over_vote_policy", choices: overVotePolicyChoices(), label: t("contestScreen.overVotePolicy.label"), defaultValue: EOverVotePolicy.ALLOWED, validate: required() }), _jsx(SelectInput, { source: "presentation.candidates_icon_checkbox_policy", choices: candidatesIconCheckboxPolicy(), label: t("contestScreen.candidatesIconCheckboxPolicy.label"), defaultValue: ECandidatesIconCheckboxPolicy.SQUARE_CHECKBOX, validate: required() }), _jsx(TextInput, { source: "presentation.pagination_policy", label: t("contestScreen.paginationPolicy.label") })] })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "contest-data-image", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "contest-data-image" ? "" : "contest-data-image";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "contest-data-image" }) }, { children: _jsx(CandidateStyles.Wrapper, { children: _jsx(CandidateStyles.Title, { children: t("electionScreen.edit.image") }) }) })), _jsx(AccordionDetails, { children: _jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, __assign({ item: true, xs: 2 }, { children: (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) &&
                                                (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) !== "" ? (_jsx("img", { width: 200, height: 200, src: "".concat(globalSettings.PUBLIC_BUCKET_URL).concat(imageUrl), alt: imageUrl })) : null })), _jsx(Grid, __assign({ item: true, xs: 10 }, { children: _jsx(DropFile, { handleFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                    return [2 /*return*/, handleFiles(files)];
                                                }); }); } }) }))] })) })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "election-data-advanced", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-advanced"
                                    ? ""
                                    : "election-data-advanced";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-advanced" }) }, { children: _jsx(ContestStyles.Wrapper, { children: _jsx(ContestStyles.Title, { children: t("electionScreen.edit.advanced") }) }) })), _jsx(AccordionDetails, { children: _jsx(FileJsonInput, { parsedValue: parsedValue, fileSource: "configuration", jsonSource: "presentation" }) })] }))] })));
        } })) : (_jsx(CircularProgress, {}));
};
var templateObject_1, templateObject_2;
